// extracted by mini-css-extract-plugin
module.exports = {"linklight":"iconlink-module--linklight--1-hTN","linkdark":"iconlink-module--linkdark--3GnKW"};